import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-add-picture-icon',
  templateUrl: './add-picture-icon.component.svg',
  styleUrls: ['./add-picture-icon.component.scss'],
  host: { '[class.color]': 'color == "primary"', '[class.offers]': 'color == "offers"' }
})
export class AddPictureIconComponent implements OnInit {
  @Input() color: 'primary' | 'offers' | 'white' = 'white';

  constructor() {}

  ngOnInit() {}
}
